var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7363 12.7976V3.61914",
    stroke: "#9094A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9487 12.7988V17.3881C17.9487 17.5619 17.8796 17.7287 17.7567 17.8516C17.6337 17.9746 17.467 18.0437 17.2931 18.0437H4.18099C4.00712 18.0437 3.84036 17.9746 3.71741 17.8516C3.59446 17.7287 3.52539 17.5619 3.52539 17.3881V12.7988",
    stroke: "#9094A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.015 9.51953L10.737 12.7976L7.45898 9.51953",
    stroke: "#9094A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAction);
export default __webpack_public_path__ + "static/media/download_action.f21f1c18aaa500018cf404a9717f7887.svg";
export { ForwardRef as ReactComponent };